export default __webpack_public_path__ + "static/N0144-2cc2dab3ad78e20790c277caea73706e.png";